/***********************************
 * NOTE: This script uses an outdated setup for actions/reducers.
 * We are now using @reduxjs/toolkit to simplify this. This script will eventually be migrated.
 * If you are setting up a new Redux view model, follow the example of the WorksheetEditor scripts instead.
 ***********************************/

import * as actions from './actions';
import * as oPath from '../../../Lib/Object/Path/Immutable';

const defaultState = {
  isRetrievingSettings: false,
};

const settings = (state = defaultState, action) => {
  switch (action.type) {
    case actions.SETTINGS_GET:
      return oPath.set(state, 'isRetrievingSettings', true);

    case actions.SETTINGS_GET_RESOLVE:
      return oPath.set(state, 'isRetrievingSettings', false);

    case actions.SETTINGS_GET_REJECT:
      return oPath.set(state, 'isRetrievingSettings', false);

    default:
      return state;
  }
};

export default settings;
